(function() {
  'use strict';

  angular
    .module('admin.users.details.collections.service', [])
    .factory('CollectionsAdminService', CollectionsAdminService);

  /** @ngInject */
  function CollectionsAdminService($http, $q, API) {

    function listChannels(userId){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/users/' + userId + '/collection/channels')
        .success(defered.resolve);

      return defered.promise;
    }

    function listSetsForChannel(userId, channelId){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/users/' + userId + '/collection/channels/' + channelId + '/sets')
        .success(defered.resolve);

      return defered.promise;
    }

    function listPrintsForSet(start, limit, userId, setId){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/users/' + userId + '/collection/sets/' + setId + '/prints?start=' + start + '&limit=' + limit)
        .success(defered.resolve);

      return defered.promise;
    }

    return{
      listChannels: listChannels,
      listSetsForChannel: listSetsForChannel,
      listPrintsForSet: listPrintsForSet,
    };

  }

})();
